module.exports = __webpack_public_path__ + "img/7H.8b3adf08.svg";